import { amplitudeLib } from 'freedom-shared';

import type { SortMode } from '@/features/offer-sort';

import type {
  SearchPageOpenParams,
  SearchResultCardCashbackPriceClickParams,
} from '../analytics';
import { extractAnalyticsDataLib } from '../analytics-data-extraction';
import { getMainPageVariant } from './main-page';

export const searchPageOpen = (params: SearchPageOpenParams) => {
  const eventProps = extractAnalyticsDataLib.searchPageOpen(params);

  if (params.success && params.offers) {
    eventProps.connect_type_range = extractAnalyticsDataLib.getConnectTypeRange(
      params.offers,
    );
  }

  amplitudeLib.logEvent('avfree_serp_page_open', {
    ...eventProps,
    main_page_variant: getMainPageVariant(),
  });
};

export const priceCalendarClick = () => {
  amplitudeLib.logEvent('avfree_price_calendar_click');
};

export const filtersClick = () => {
  amplitudeLib.logEvent('avfree_filters_click');
};

export const resetFiltersClick = (source: string) => {
  amplitudeLib.logEvent('avfree_filters_reset_click', { source });
};

export const applyFiltersClick = (appliedFilters?: Record<string, unknown>) => {
  amplitudeLib.logEvent('avfree_filters_apply_click', appliedFilters);
};

export const sortSeparateClick = () => {
  amplitudeLib.logEvent('sort_separate_click');
};

export const airlinesSeparateClick = () => {
  amplitudeLib.logEvent('airlines_separate_click');
};

export const timeSeparateClick = () => {
  amplitudeLib.logEvent('time_separate_click');
};

export const transfersSeparateClick = () => {
  amplitudeLib.logEvent('transfers_separate_click');
};

export const airlinesSeparateApplied = (params: {
  airline_choosed: string;
}) => {
  amplitudeLib.logEvent('airlines_separate_applied', params);
};

export const timeSeparateApplied = (params: { travel_time: string }) => {
  amplitudeLib.logEvent('time_separate_applied', params);
};

export const transfersSeparateApplied = (params: {
  transfers: string;
  no_night_transfer: string;
}) => {
  amplitudeLib.logEvent('transfers_separate_applied', params);
};

export const changeSortMode = ({ sortMode }: { sortMode: SortMode }) => {
  amplitudeLib.logEvent('avfree_change_sort_mode', { sort_mode: sortMode });
};

export const directFlightsClick = (params: {
  airline_choosen: string;
  time_choosen?: string;
}) => {
  const eventParams: Record<string, string> = {
    airline_choosen: params.airline_choosen,
  };

  if (params.time_choosen) {
    eventParams.time_choosen = params.time_choosen;
  }

  amplitudeLib.logEvent('avfree_direct_flights_click', eventParams);
};

export const directFlightsShowMore = () => {
  amplitudeLib.logEvent('avfree_direct_flights_showmore');
};

export const directFlightsView = () => {
  amplitudeLib.logEvent('avfree_direct_flights_view');
};

export const openChangeSearchParams = () => {
  amplitudeLib.logEvent('avfree_open_change_search_params');
};

export const priceCalendarShow = () => {
  amplitudeLib.logEvent('avfree_price_calendar_show');
};

export const priceSwipeRight = (direction: 'from' | 'to') => {
  amplitudeLib.logEvent('avfree_price_swipe_right', { direction });
};

export const priceSwipeLeft = (direction: 'from' | 'to') => {
  amplitudeLib.logEvent('avfree_price_swipe_left', { direction });
};

export const priceCalendarClose = () => {
  amplitudeLib.logEvent('avfree_price_calendar_close');
};

export const priceCalendarOffersShow = () => {
  amplitudeLib.logEvent('avfree_price_calendar_offers_show');
};

export const serpScroll = (params: {
  scroll_depth?: number;
  scroll_offers?: number;
}) => {
  amplitudeLib.logEvent('avfree_serp_scroll', params);
};

export const promocodeApplied = (params: { value: string }) => {
  amplitudeLib.logEvent('avfree_promocode_applied', params);
};

export const shareButtonClicked = (params: { source?: string }) => {
  amplitudeLib.logEvent('avfree_share_button_clicked', {
    ...(params?.source ? { source: params?.source } : {}),
  });
};

export const searchResultCardCashbackPriceClick = (
  params: SearchResultCardCashbackPriceClickParams,
) => {
  amplitudeLib.logEvent('free_cashback_price_click', params);
};
